/** Function allowing to perform heavy synchronous array iterations asynchronously without blocking the event loop *
 * @param {Array} arr Array to iterate through.
 * @param {Function|String} func Static function to be called with arr as a first parameter and callback as second parameter.
 * Or string representing the name of the function of the arr to be called with callback as a par
 * @param {Function} callback The iterator callback for the func
 * @param {Number} chunkSize The size of chunk
 * @param {Function} consolidator Function consolidating results of processing each chunk
 */
export const asyncLoop = async (
  arr = [],
  func = () => {},
  callback = () => {},
  chunkSize = 1,
  consolidator = (arr) => arr
) => {
  const isFuncString = typeof func === "string" || func instanceof String;
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize)
    await new Promise((resolve, reject) => {
      const chunk = arr.slice(i, i + chunkSize);
      setTimeout(() => {
        try {
          let chunkResult;
          if (isFuncString) chunkResult = chunk[func](callback);
          else chunkResult = func(chunk, callback);
          result.push(chunkResult);
          resolve();
        } catch (error) {
          reject(error);
        }
      }, 0);
    });
  return consolidator(result);
};

export const serialAsyncForEach = async (array, callback) => {
  for (const item of array) await callback(item);
};

export const syncToAsync = (syncFunc) =>
  new Promise((resolve, reject) =>
    setTimeout(() => {
      try {
        const result = syncFunc();
        resolve(result);
      } catch (error) {
        reject(error);
      }
    }, 0)
  );
